import ActionConstants from "../action-constants";
import { createReducer } from "../utils/redux-util";
import Reducer from "./reducer";

class ReviewOrderReducer extends Reducer {
    static showReviewOrder(state = initialState, action) {
        
        return {
            ...state,
            reviewOrderData: {
                checkInsideReviewOrder: action.payload
            }
                
        }
    }
}

const reviewOrderActionHandlers = {
    [ActionConstants.SHOW_REVIEW_ORDER]: ReviewOrderReducer.showReviewOrder
}

const initialState = {
    reviewOrderData: {
        checkInsideReviewOrder: false
    }
}

export const reviewOrderData = createReducer(initialState, reviewOrderActionHandlers)